"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Collapse_1 = __importDefault(require("react-bootstrap/Collapse"));
exports.AcSideMenu = function (_a) {
    var icon = _a.icon, title = _a.title, children = _a.children;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { onClick: function () { return setOpen(!open); }, style: { cursor: 'pointer' }, className: "d-flex justify-content-between align-items-center py-2" },
            react_1.default.createElement("div", { className: "fs-14 " + (open ? 'text-apzlinkblue' : 'text-primary') },
                icon && react_1.default.createElement("i", { className: icon + " mr-1 fs-20 fa-fw" }),
                react_1.default.createElement("span", { className: "font-weight-bold" }, title)),
            react_1.default.createElement("i", { className: "fas " + (open ? 'fa-minus text-apzlinkblue' : 'fa-plus text-secondary') + " mr-1 fa-fw" })),
        react_1.default.createElement(Collapse_1.default, { in: open },
            react_1.default.createElement("div", null, children)),
        react_1.default.createElement("div", { className: "mb-4" })));
};
//# sourceMappingURL=AcSideMenu.js.map